<div class="page-container">
  <div class="cards-grid mb-4">
    <div class="summary-card">
      <div class="card-content">
        <p class="card-title">Total Earned</p>
        <h3 class="card-value">₹{{ totalEarned | number: '1.0-2' }}</h3>
      </div>
      <div class="card-icon-bg">
        <i class="fa-solid fa-sack-dollar"></i>
      </div>
    </div>
    <div class="summary-card">
      <div class="card-content">
        <p class="card-title">Available Balance</p>
        <h3 class="card-value">₹{{ availableBalance | number: '1.0-2' }}</h3>
      </div>
      <div class="card-icon-bg">
        <i class="fa-solid fa-wallet"></i>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table class="custom-table">
      <thead>
        <tr>
          <th>Sr.No</th>
          <th>Order ID</th>
          <th>Total Price</th>
          <th>Order Date</th>
          <th>Commission Earned</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredCommissions">
          <td>{{ item.srNo }}</td>
          <td class="fw-bold">{{ item.orderId }}</td>
          <td>₹{{ item.price | number: '1.0-2' }}</td>
          <td>{{ item.date }}</td>
          <td class="text-success fw-bold">₹{{ item.commission | number: '1.0-2' }}</td>
        </tr>

        <tr *ngIf="filteredCommissions.length === 0">
          <td colspan="5" class="no-data-cell" style="text-align: center; padding: 40px">
            <div class="empty-state">
              <h4 style="color: #666">No Commission History Found</h4>
              <p style="color: #888; font-size: 13px" *ngIf="currentSearchText">
                No results matching "{{ currentSearchText }}"
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
